// extracted by mini-css-extract-plugin
export default {"permissionDeniedWrapper":"permissionDeniedWrapper__3-qNJ","permissionDeniedHeader":"permissionDeniedHeader__1vNAq","permissionDeniedMsg":"permissionDeniedMsg__1Tfrd"};